import React from 'react'
import './WppBubble.css'

const WppBubble = () => (
    <a
        href="https://wa.me/5492266494431"
        target="_blank"
        rel="noopener noreferrer"
        className="wpp-bubble"
        aria-label="Contactar por WhatsApp"
    >
        <img src="wpp-logop.webp" alt="WhatsApp" />
    </a>
)

export default WppBubble
